import { render, staticRenderFns } from "./MasterdataReasonsCreateModal.vue?vue&type=template&id=0c56cba9"
import script from "./MasterdataReasonsCreateModal.vue?vue&type=script&lang=js"
export * from "./MasterdataReasonsCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports